var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 5.625C1.25 5.12772 1.44754 4.65081 1.79917 4.29917C2.15081 3.94754 2.62772 3.75 3.125 3.75H16.875C17.3723 3.75 17.8492 3.94754 18.2008 4.29917C18.5525 4.65081 18.75 5.12772 18.75 5.625V6.25H1.25V5.625ZM1.25 7.5H18.75V14.375C18.75 14.8723 18.5525 15.3492 18.2008 15.7008C17.8492 16.0525 17.3723 16.25 16.875 16.25H3.125C2.62772 16.25 2.15081 16.0525 1.79917 15.7008C1.44754 15.3492 1.25 14.8723 1.25 14.375V7.5ZM11.25 11.875C11.0842 11.875 10.9253 11.9408 10.8081 12.0581C10.6908 12.1753 10.625 12.3342 10.625 12.5C10.625 12.6658 10.6908 12.8247 10.8081 12.9419C10.9253 13.0592 11.0842 13.125 11.25 13.125H15C15.1658 13.125 15.3247 13.0592 15.4419 12.9419C15.5592 12.8247 15.625 12.6658 15.625 12.5C15.625 12.3342 15.5592 12.1753 15.4419 12.0581C15.3247 11.9408 15.1658 11.875 15 11.875H11.25Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCc);
export default __webpack_public_path__ + "static/media/cc.484a5d7899af4574a4c87a80cead934d.svg";
export { ForwardRef as ReactComponent };